import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommonContext } from "./useCommon";

export default function CommonProvider({children}) {
  const [lang, setLang] = useState(
   () => {
    const l = window.localStorage.getItem("RUNBIT_LANG") || "zh"
    return ['en','zh'].includes(l) ?  l : 'zh'

   } 
  );
  const changeLang = (val) => {
    window.localStorage.setItem("RUNBIT_LANG",val)
    window.document.documentElement.lang = val
    setLang(val)
  }


  return (
    <CommonContext.Provider
      value={{
        lang,
        changeLang
      }}
    >{children}</CommonContext.Provider>
  );
}
